// This must be the first line in src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'assets/styles/index.scss';
import App from './App';

const root = createRoot(document.getElementById('root'));
root.render(<App />);
